const initialStates = {
  edit_email_notifications: {
    rcpt: '',
    subject: '',
    body: '',
  },
  access_token_edit: {
    uid: '',
    revoke_api_access: false,
  },
  reply_message: {
    subject: '',
    body: '',
  },
  store_message: {
    subject: '',
    body: '',
  },
  playground: {
    spinner: 1,
    range_slider: 75,
  },
  registration: {
    outlet_validation: {
      customer_number: '',
      eircode_or_passcode: ''
    },
  },
  yourStore: {
    customer_number: '',
    updated_name: '',
    updated_address_1: '',
    updated_address_2: '',
    updated_address_3: '',
    updated_town: '',
    updated_country: '',
    updated_eircode: '',
    dont_know_eircode: false
  },
  login: {
    login: '',
    password: ''
  },
  resetPW: {
    step1: {
      email: '',
      mobile: '',
    },
    step2: {
      pin: '',
    },
    step3: {
      answer1: '',
      answer2: ''
    },
    step4: {
      password: '',
      password_confirmation: ''
    },
  },
  my_staff: {
    outlet_id: '',
  },
  staff_member: {
    title: '',
    first_name: '',
    last_name: '',
    email: '',
    mobile: '',
    outlet_id: '',
    permission_ids: {},
    agreed: false,
    is_champion: false
  },
  store: {
    staff_member: {
      title: '',
      first_name: '',
      last_name: '',
      email: '',
      mobile: '',
      outlet_id: '',
      permission_ids: {},
    }
  },
  store_summary: [],
  about_you: {
    marketing_consent: {
      marketing_accepted: null,
      marketing_accepted_confirm: null,
    },
    user: {
      title: '',
      first_name: '',
      last_name: '',
      date_of_birth: '',
      gender: 'male',
      marketing_accepted: null,
      personal_address_1: '',
      personal_address_2: '',
      personal_address_3: '',
      personal_address_4: '',
      personal_eircode: '',
      comms_email: true,
      comms_mobile: true,
      email: '',
      mobile: '',
      password: '',
      password_confirmation: '',
      security_answers_attributes: [
        {
          security_question_id: '',
          answer: '',
        },
        {
          security_question_id: '',
          answer: '',
        }
      ],
      t_cs1: false,
      t_cs2: true,
    }
  },
  updatePw: {
    user: {
      current_password: '',
      password: '',
      password_confirmation: ''
    }
  },
  updateSecQ: {
    user: {
      current_password: '',
      security_answers_attributes: [
        {
          security_question_id: '',
          answer: ''
        },
        {
          security_question_id: '',
          answer: ''
        }
      ]
    },
    owner: {
      security_answers_attributes: [
        {
          security_question_id: '',
          answer: '',
          id: ''
        },
        {
          security_question_id: '',
          answer: '',
          id: ''
        }
      ]
    }
  },
  my_profile: {
    personal_address_1: '',
    personal_address_2: '',
    personal_address_3: '',
    personal_address_4: '',
    personal_eircode: '',
    billing_address_1: '',
    billing_address_2: '',
    billing_address_3: '',
    billing_address_4: '',
    billing_eircode: '',
    comms_email: false,
    comms_mobile: false,
    email: '',
    mobile: '',
    marketing_categories: [],
  },
  contact_us: {
    title: '',
    name: '',
    store_name: '',
    email: '',
    telephone: '',
    type_of_enquiry: '',
    message: ''
  },
  contact_us_team: {
    from: '',
    subject: '',
    message: '',
  },
  admin_my_profile: {
    first_name: '',
    last_name: '',
    title: '',
    comms_email: false,
    comms_mobile: false,
    email: '',
    mobile: ''
  },
  admin_edit_user: {
    title: '',
    first_name: '',
    last_name: '',
    usergroup: '',
    date_of_birth: '',
    comms_email: false,
    email: '',
    status: '',
    locked: 'no'
  },
  admin_welcome: {
    password: '',
    password_confirmation: '',
    t_cs1: false,
    t_cs2: false,
    invitation_token: '',
    security_answers_attributes: [
      {
        security_question_id: '',
        answer: '',
      },
      {
        security_question_id: '',
        answer: '',
      }
    ],
  },
  admin_usergroup: {
    name: '',
    permission_ids: {}
  },
  admin_level: {
    name: '',
    next_level: {},
    active: 'true'
  },
  admin_update_level: {
    outlet_id: '',
    new_level_id: '',
    reason: ''
  },
  admin_navigationlink: {
    name: '',
    group_ids: [],
    url: '',
    permission_ids: {},
    groups: {}
  },
  admin_notification_edit: {
    event: '',
    to_associated_user: 'true',
    custom_to: '',
    email: false,
    email_subject: '',
    email_body: '',
    sms: false,
    sms_body: '',
    site_message: false,
    site_body: ''
  },
  admin_user: {
    details: {
      title: '',
      first_name: '',
      last_name: '',
      date_of_birth: '',
      personal_address_1: '',
      personal_address_2: '',
      personal_address_3: '',
      personal_address_4: '',
      personal_eircode: '',
      comms_email: false,
      comms_mobile: false,
      email: '',
      mobile: '',
      status: '',
      account_locked: '',
    },
    edit: {
      title: '',
      first_name: '',
      last_name: '',
      comms_email: 'true',
      email: '',
      status: '',
      account_locked: '',
      user_group_id: '',
      employee_code: '',
      ror_code: '',
      rdr_code: '',
      rbm_code: '',
      ffde_code: '',
      am_code: '',
      abm_code: '',
      abm_relief: {
        abm_relief_user_id: '',
        start_date: '',
        end_date: ''
      }
    }
  },
  page: {
    name: '',
    page_template: '',
    login_required: ''
  },
  admin_delink: {
    delink_date: new Date(),
    delink_reason: '',
    outlet: '',
    supress_notification: false,
  },
  admin_category: {
    name: ''
  },
  admin_brand: {
    name: '',
    categories: [],
    abm_codes: [],
    status: ''
  },
  admin_outlet_view: {
    use_delivery_address: false,
    groups: [],
    invalidate_scans: {
      staff_member: '',
      invalidate_from_date: '',
      invalidate_to_date: ''
    }
  },
  admin_product_save: {
    name: '',
    status: 'ACTIVE',
    special_new: true,
    special_featured: false,
    special_reward: true,
    special_sell_it: false,
    exclude_from_marketing: false,
    hyperlink: '',
    sku: '',
    product_eans: '',
    category_id: '',
    brand_id: '',
    group_ids: [],
    rsp: '',
    outer_price: 0,
    units_per_outer: 0,
    tar: '',
    nicotine: '',
    flavour: '',
    max_per_order: 0,
    product_exceptions: [],
    stock_status: 'In Stock',
    photo: '',
    variant: '',
    northern_ireland_sku: ''
  },
  admin_group_save: {
    name: '',
  },
  admin_feature_toggle_save: {
    name: '',
    description: '',
    enabled: 'false'
  },
  admin_ppc: {
    settings: {
      load_date: '',
      load_frequency: '',
      kyc_limit_euro: '',
      load_fee_percent: '',
      points_per_euro: '',
      ppc_management_url: '',
      postcodeplan_redemption_date: '',
      postcodeplan_redemption_frequency: '',
      mini_chain_postcodeplan_redemption_date: '',
      mini_chain_postcodeplan_redemption_frequency: '',
      mini_chain_personal_redemption_date: '',
      mini_chain_personal_redemption_dates: [],
      mini_chain_ngp_redemption_date: '',
      mini_chain_ngp_redemption_dates: []
    },
    management: {
      user: {
        title: '',
        first_name: '',
        last_name: '',
        date_of_birth: '',
        address_1: '',
        address_2: '',
        town: '',
        county: '',
        eircode: '',
        kyc_status: '',
        email: '',
        mobile: ''
      },
      load: {
        points: 0,
        value: 0,
        status: ''
      },
      manual_load: {
        points: 0,
        value: 0,
        pot: ''
      }
    }
  },
  admin_damaged_barcode_submission_view: {
    product_code: '',
    outer_code: '',
  },
  admin_decline_scan_orverride_dialog: {
    decline_reason: ''
  },
  admin_pip_epos_submissions_form_decline_dialog: {
    decline_reason: ''
  },
  admin_pip_epos_submissions: {
    notes: '',
    pip_epos_proof_of_purchases: '',
    pip_epos_proof_of_purchases_attributes: []
  },
  admin_damaged_barcode_dialog: {
    decline_reason: ''
  },
  my_profile_change_email_dialog: {
    password: ''
  },
  ppc_management_url: '',
  incentives: {
    name: '',
    image: '',
    start_date: '',
    end_date: '',
    current_date_before_start_date: false,
    submission_grace_period: '',
    kind: '',
    incentive_type: '',
    target: '',
    default_target: '',
    maximum_points: '',
    points_to_target: '',
    points_to_target_2: '',
    points_after_target: '',
    display_from: '',
    display_to: '',
    product_ids: [],
    percentage_calculate_from: '',
    percentage_calculate_to: '',
    bonus_points_enabled: 'false',
    bonus_points_to_target: '',
    bonus_points_to_target_2: '',
    bonus_points_after_target: '',
    bonus_points_to: '',
    bonus_points_from: '',
    bonus_link: '',
    game_qualification_chance: 100,
    game_levels: {}
  },
  admin_settings: {
    overarching_threshold: 0,
    scan_override_threshold: 0,
    game_expiry_days: 0,
    achievement_target: 0,
    scan_target: 0
  },
  admin_non_ppc_mc_settings: {
    point_redemption_date: '',
    point_redemption_dates: []
  },
  admin_news: {
    category: {
      name: ''
    },
    article: {
      title: '',
      title_text_colour: 'Red',
      news_category_id: 0,
      status: '',
      display_from_date: '',
      display_to_date: '',
      display_location: '',
      featured: '',
      mc_only_outlets: false,
      non_mc_only_outlets: false,
      video_link: '',
      game_link: '',
      cataboom_id: '',
      external_url: '',
      permission_ids: [],
      linked_article_ids: [],
      group_ids: [],
      tags: []
    }
  },
  admin_files: {
    upload: {
    },
    edit: {
      name: ''
    }
  },
  admin_data_import: {
    file: ''
  },
  points_expiry: {
    day: '',
    month: ''
  },
  user_point: {
    value: '',
    description: '',
    owner: '',
    outlet: '',
    point_pot: ''
  },
  home_page_carousel: {
    position: '',
    title: '',
    text: '',
    text_color: 'White',
    button_color: 'Red',
    button_text_color_when_hover: '',
    button_label: '',
    image: '',
    mobile_image: '',
    button_link: '',
    button_article_link: '0',
    display_from_date: '',
    display_to_date: '',
    text_alignment: 'left',
    permission_ids: {},
    group_ids: []
  },
  home_page_carousel_setting: {
    slide_speed: ''
  },
  personal_rewards: {
    first_name: '',
    last_name: '',
    email: '',
    accept_terms: false
  },
  tile: {
    link: '',
    label: '',
    button_color: '',
    button_text_color_when_hover: '',
    default_image: '',
    image: ''
  },
  point_statement: {
    outlet_id: '',
    transaction_type: '',
    date_from: '',
    date_to: '',
  },
  team_welcome: {
    password: '',
    password_confirmation: '',
    t_cs1: false,
    t_cs2: false,
    invitation_token: '',
    security_answers_attributes: [
      {
        security_question_id: '',
        answer: '',
      },
      {
        security_question_id: '',
        answer: '',
      }
    ],
  },
  admin_campaign_save: {
    name: '',
    start_date: '',
    end_date: '',
    image: '',
    campaign_type: 'tobacco'
  },
  admin_submission: {
    number_of_outers: '',
    audit_completed: false,
    audit_amount: '',
    outlet_id: '',
    incentive_id: '',
    postcodeplan_objective_id: '',
    proof_type: '',
    decline_reason: '',
    proof_of_purchases: '',
    proof_of_purchases_attributes: [],
    outlet_name: '',
    outlet_code: '',
    notes: '',
    validation_notes: '',
    status: null,
    wholesaler_id: '',
    number_of_packs_solds: [],
    audit_amounts: [],
    rep_comment: '',
    start_date: '',
    end_date: '',
    further_validation_required: false
  },
  stock_it: {
    name: '',
    description: '',
    image: '',
    groups: [],
    product_ids: [],
    levels: {},
    maximum_points: '',
    start_date: '',
    end_date: '',
    sell_out_qty: '',
    display_from_date: '',
    display_to_date: '',
    current_date_before_start_date: false
  },
  postcode_plan: {
    name: '',
    description: '',
    start_date: '',
    end_date: '',
    postcodes: [],
    zones: [],
    objective_type: 'Auto-EPOS',
    objective_types: [],
    groups: [],
    products: [],
    opt_in_bonus_points: '',
    administration_validation_threshold: '',
    display_from_date: '',
    display_to_date: '',
    opt_in_bonus_outlets: '',
    thresholds: {},
  },
  submission: {
    number_of_outers: '',
    outlet_id: '',
    incentive_id: '',
    proof_type: '',
    proof_of_purchases: '',
    proof_of_purchases_attributes: [],
    store_name_confirm: '',
    dates_confirm: '',
    evidence_confirm: '',
    sell_it_objectives: [],
    wholesaler_id: ''
  },
  pointsType: {
    pointsType: '',
    icon_uid: '',
    name: '',
    link: {},
    news_feed: false
  },
  postcodePlanObjective: {
    outlet_id: '',
    postcodeplan_objective_id: '',
    proof_of_purchases: '',
    proof_of_purchases_attributes: []
  },
  autoEposPriceItPlus: {
    outlet_id: '',
    postcodeplan_objective_id: '',
    week_of_sale: '',
    proof_of_purchases: '',
    proof_of_purchases_attributes: []
  },
  marketingConsents: [],
  admin_marketing_category: {
    name_new: ''
  },
  admin_qr_code_campaign: {
    campaign_unique_id: '',
    abm_codes: [],
    mini_chains: 0,
    start_date: '',
    end_date: '',
    campaign_type: 'game',
    cataboom_id: '',
    points_per_qr: 0,
    group_ids: []
  }
};

const pushNotificationTemplate = initialStates.push_notification_template;

export { pushNotificationTemplate, initialStates };

export default initialStates;
